// AUTOGENERATED by scripts/codegen/generate-market-catalogue.ts — do not edit by hand.
// Run `pnpm generate:market-catalogue` to refresh, then commit the result.

export const PREFLIGHT_MARKET_KINDS = ['GLOBAL', 'CONTINENT', 'COUNTRY'] as const;
export type PreflightMarketKind = (typeof PREFLIGHT_MARKET_KINDS)[number];

/** Global is not an ISO code — it is this product's own catalogue key. */
export const GLOBAL_MARKET_CODE = 'GLOBAL';

/**
 * Ceiling for a stored market name. The market name column matches it, so a
 * catalogue entry can never be truncated on write.
 */
export const MARKET_CATALOGUE_NAME_MAX_LENGTH = 64;

/**
 * Ceiling for a stored market code. The market and catalogue code columns
 * match it, so a catalogue entry can never be truncated on write.
 */
export const MARKET_CATALOGUE_CODE_MAX_LENGTH = 8;

export type PreflightMarketCatalogueEntry = {
    kind: PreflightMarketKind;
    code: string;
    name: string;
};

/** Global first, then continents, then countries — both sorted by name. */
export const PREFLIGHT_MARKET_CATALOGUE = [
    { kind: 'GLOBAL', code: 'GLOBAL', name: 'Global' },
    { kind: 'CONTINENT', code: 'AF', name: 'Africa' },
    { kind: 'CONTINENT', code: 'AN', name: 'Antarctica' },
    { kind: 'CONTINENT', code: 'AS', name: 'Asia' },
    { kind: 'CONTINENT', code: 'EU', name: 'Europe' },
    { kind: 'CONTINENT', code: 'NA', name: 'North America' },
    { kind: 'CONTINENT', code: 'OC', name: 'Oceania' },
    { kind: 'CONTINENT', code: 'SA', name: 'South America' },
    { kind: 'COUNTRY', code: 'AF', name: 'Afghanistan' },
    { kind: 'COUNTRY', code: 'AX', name: 'Aland' },
    { kind: 'COUNTRY', code: 'AL', name: 'Albania' },
    { kind: 'COUNTRY', code: 'DZ', name: 'Algeria' },
    { kind: 'COUNTRY', code: 'AS', name: 'American Samoa' },
    { kind: 'COUNTRY', code: 'AD', name: 'Andorra' },
    { kind: 'COUNTRY', code: 'AO', name: 'Angola' },
    { kind: 'COUNTRY', code: 'AI', name: 'Anguilla' },
    { kind: 'COUNTRY', code: 'AQ', name: 'Antarctica' },
    { kind: 'COUNTRY', code: 'AG', name: 'Antigua and Barbuda' },
    { kind: 'COUNTRY', code: 'AR', name: 'Argentina' },
    { kind: 'COUNTRY', code: 'AM', name: 'Armenia' },
    { kind: 'COUNTRY', code: 'AW', name: 'Aruba' },
    { kind: 'COUNTRY', code: 'AC', name: 'Ascension Island' },
    { kind: 'COUNTRY', code: 'AU', name: 'Australia' },
    { kind: 'COUNTRY', code: 'AT', name: 'Austria' },
    { kind: 'COUNTRY', code: 'AZ', name: 'Azerbaijan' },
    { kind: 'COUNTRY', code: 'BS', name: 'Bahamas' },
    { kind: 'COUNTRY', code: 'BH', name: 'Bahrain' },
    { kind: 'COUNTRY', code: 'BD', name: 'Bangladesh' },
    { kind: 'COUNTRY', code: 'BB', name: 'Barbados' },
    { kind: 'COUNTRY', code: 'BY', name: 'Belarus' },
    { kind: 'COUNTRY', code: 'BE', name: 'Belgium' },
    { kind: 'COUNTRY', code: 'BZ', name: 'Belize' },
    { kind: 'COUNTRY', code: 'BJ', name: 'Benin' },
    { kind: 'COUNTRY', code: 'BM', name: 'Bermuda' },
    { kind: 'COUNTRY', code: 'BT', name: 'Bhutan' },
    { kind: 'COUNTRY', code: 'BO', name: 'Bolivia' },
    { kind: 'COUNTRY', code: 'BQ', name: 'Bonaire' },
    { kind: 'COUNTRY', code: 'BA', name: 'Bosnia and Herzegovina' },
    { kind: 'COUNTRY', code: 'BW', name: 'Botswana' },
    { kind: 'COUNTRY', code: 'BV', name: 'Bouvet Island' },
    { kind: 'COUNTRY', code: 'BR', name: 'Brazil' },
    { kind: 'COUNTRY', code: 'IO', name: 'British Indian Ocean Territory' },
    { kind: 'COUNTRY', code: 'VG', name: 'British Virgin Islands' },
    { kind: 'COUNTRY', code: 'BN', name: 'Brunei' },
    { kind: 'COUNTRY', code: 'BG', name: 'Bulgaria' },
    { kind: 'COUNTRY', code: 'BF', name: 'Burkina Faso' },
    { kind: 'COUNTRY', code: 'BI', name: 'Burundi' },
    { kind: 'COUNTRY', code: 'CV', name: 'Cabo Verde' },
    { kind: 'COUNTRY', code: 'KH', name: 'Cambodia' },
    { kind: 'COUNTRY', code: 'CM', name: 'Cameroon' },
    { kind: 'COUNTRY', code: 'CA', name: 'Canada' },
    { kind: 'COUNTRY', code: 'KY', name: 'Cayman Islands' },
    { kind: 'COUNTRY', code: 'CF', name: 'Central African Republic' },
    { kind: 'COUNTRY', code: 'TD', name: 'Chad' },
    { kind: 'COUNTRY', code: 'CL', name: 'Chile' },
    { kind: 'COUNTRY', code: 'CN', name: 'China' },
    { kind: 'COUNTRY', code: 'CX', name: 'Christmas Island' },
    { kind: 'COUNTRY', code: 'CC', name: 'Cocos (Keeling) Islands' },
    { kind: 'COUNTRY', code: 'CO', name: 'Colombia' },
    { kind: 'COUNTRY', code: 'KM', name: 'Comoros' },
    { kind: 'COUNTRY', code: 'CK', name: 'Cook Islands' },
    { kind: 'COUNTRY', code: 'CR', name: 'Costa Rica' },
    { kind: 'COUNTRY', code: 'HR', name: 'Croatia' },
    { kind: 'COUNTRY', code: 'CU', name: 'Cuba' },
    { kind: 'COUNTRY', code: 'CW', name: 'Curacao' },
    { kind: 'COUNTRY', code: 'CY', name: 'Cyprus' },
    { kind: 'COUNTRY', code: 'CZ', name: 'Czechia' },
    { kind: 'COUNTRY', code: 'CD', name: 'Democratic Republic of the Congo' },
    { kind: 'COUNTRY', code: 'DK', name: 'Denmark' },
    { kind: 'COUNTRY', code: 'DJ', name: 'Djibouti' },
    { kind: 'COUNTRY', code: 'DM', name: 'Dominica' },
    { kind: 'COUNTRY', code: 'DO', name: 'Dominican Republic' },
    { kind: 'COUNTRY', code: 'TL', name: 'East Timor' },
    { kind: 'COUNTRY', code: 'EC', name: 'Ecuador' },
    { kind: 'COUNTRY', code: 'EG', name: 'Egypt' },
    { kind: 'COUNTRY', code: 'SV', name: 'El Salvador' },
    { kind: 'COUNTRY', code: 'GQ', name: 'Equatorial Guinea' },
    { kind: 'COUNTRY', code: 'ER', name: 'Eritrea' },
    { kind: 'COUNTRY', code: 'EE', name: 'Estonia' },
    { kind: 'COUNTRY', code: 'SZ', name: 'Eswatini' },
    { kind: 'COUNTRY', code: 'ET', name: 'Ethiopia' },
    { kind: 'COUNTRY', code: 'FK', name: 'Falkland Islands' },
    { kind: 'COUNTRY', code: 'FO', name: 'Faroe Islands' },
    { kind: 'COUNTRY', code: 'FJ', name: 'Fiji' },
    { kind: 'COUNTRY', code: 'FI', name: 'Finland' },
    { kind: 'COUNTRY', code: 'FR', name: 'France' },
    { kind: 'COUNTRY', code: 'GF', name: 'French Guiana' },
    { kind: 'COUNTRY', code: 'PF', name: 'French Polynesia' },
    { kind: 'COUNTRY', code: 'TF', name: 'French Southern Territories' },
    { kind: 'COUNTRY', code: 'GA', name: 'Gabon' },
    { kind: 'COUNTRY', code: 'GM', name: 'Gambia' },
    { kind: 'COUNTRY', code: 'GE', name: 'Georgia' },
    { kind: 'COUNTRY', code: 'DE', name: 'Germany' },
    { kind: 'COUNTRY', code: 'GH', name: 'Ghana' },
    { kind: 'COUNTRY', code: 'GI', name: 'Gibraltar' },
    { kind: 'COUNTRY', code: 'GR', name: 'Greece' },
    { kind: 'COUNTRY', code: 'GL', name: 'Greenland' },
    { kind: 'COUNTRY', code: 'GD', name: 'Grenada' },
    { kind: 'COUNTRY', code: 'GP', name: 'Guadeloupe' },
    { kind: 'COUNTRY', code: 'GU', name: 'Guam' },
    { kind: 'COUNTRY', code: 'GT', name: 'Guatemala' },
    { kind: 'COUNTRY', code: 'GG', name: 'Guernsey' },
    { kind: 'COUNTRY', code: 'GN', name: 'Guinea' },
    { kind: 'COUNTRY', code: 'GW', name: 'Guinea-Bissau' },
    { kind: 'COUNTRY', code: 'GY', name: 'Guyana' },
    { kind: 'COUNTRY', code: 'HT', name: 'Haiti' },
    { kind: 'COUNTRY', code: 'HM', name: 'Heard Island and McDonald Islands' },
    { kind: 'COUNTRY', code: 'HN', name: 'Honduras' },
    { kind: 'COUNTRY', code: 'HK', name: 'Hong Kong' },
    { kind: 'COUNTRY', code: 'HU', name: 'Hungary' },
    { kind: 'COUNTRY', code: 'IS', name: 'Iceland' },
    { kind: 'COUNTRY', code: 'IN', name: 'India' },
    { kind: 'COUNTRY', code: 'ID', name: 'Indonesia' },
    { kind: 'COUNTRY', code: 'IR', name: 'Iran' },
    { kind: 'COUNTRY', code: 'IQ', name: 'Iraq' },
    { kind: 'COUNTRY', code: 'IE', name: 'Ireland' },
    { kind: 'COUNTRY', code: 'IM', name: 'Isle of Man' },
    { kind: 'COUNTRY', code: 'IL', name: 'Israel' },
    { kind: 'COUNTRY', code: 'IT', name: 'Italy' },
    { kind: 'COUNTRY', code: 'CI', name: 'Ivory Coast' },
    { kind: 'COUNTRY', code: 'JM', name: 'Jamaica' },
    { kind: 'COUNTRY', code: 'JP', name: 'Japan' },
    { kind: 'COUNTRY', code: 'JE', name: 'Jersey' },
    { kind: 'COUNTRY', code: 'JO', name: 'Jordan' },
    { kind: 'COUNTRY', code: 'KZ', name: 'Kazakhstan' },
    { kind: 'COUNTRY', code: 'KE', name: 'Kenya' },
    { kind: 'COUNTRY', code: 'KI', name: 'Kiribati' },
    { kind: 'COUNTRY', code: 'XK', name: 'Kosovo' },
    { kind: 'COUNTRY', code: 'KW', name: 'Kuwait' },
    { kind: 'COUNTRY', code: 'KG', name: 'Kyrgyzstan' },
    { kind: 'COUNTRY', code: 'LA', name: 'Laos' },
    { kind: 'COUNTRY', code: 'LV', name: 'Latvia' },
    { kind: 'COUNTRY', code: 'LB', name: 'Lebanon' },
    { kind: 'COUNTRY', code: 'LS', name: 'Lesotho' },
    { kind: 'COUNTRY', code: 'LR', name: 'Liberia' },
    { kind: 'COUNTRY', code: 'LY', name: 'Libya' },
    { kind: 'COUNTRY', code: 'LI', name: 'Liechtenstein' },
    { kind: 'COUNTRY', code: 'LT', name: 'Lithuania' },
    { kind: 'COUNTRY', code: 'LU', name: 'Luxembourg' },
    { kind: 'COUNTRY', code: 'MO', name: 'Macao' },
    { kind: 'COUNTRY', code: 'MG', name: 'Madagascar' },
    { kind: 'COUNTRY', code: 'MW', name: 'Malawi' },
    { kind: 'COUNTRY', code: 'MY', name: 'Malaysia' },
    { kind: 'COUNTRY', code: 'MV', name: 'Maldives' },
    { kind: 'COUNTRY', code: 'ML', name: 'Mali' },
    { kind: 'COUNTRY', code: 'MT', name: 'Malta' },
    { kind: 'COUNTRY', code: 'MH', name: 'Marshall Islands' },
    { kind: 'COUNTRY', code: 'MQ', name: 'Martinique' },
    { kind: 'COUNTRY', code: 'MR', name: 'Mauritania' },
    { kind: 'COUNTRY', code: 'MU', name: 'Mauritius' },
    { kind: 'COUNTRY', code: 'YT', name: 'Mayotte' },
    { kind: 'COUNTRY', code: 'MX', name: 'Mexico' },
    { kind: 'COUNTRY', code: 'FM', name: 'Micronesia' },
    { kind: 'COUNTRY', code: 'MD', name: 'Moldova' },
    { kind: 'COUNTRY', code: 'MC', name: 'Monaco' },
    { kind: 'COUNTRY', code: 'MN', name: 'Mongolia' },
    { kind: 'COUNTRY', code: 'ME', name: 'Montenegro' },
    { kind: 'COUNTRY', code: 'MS', name: 'Montserrat' },
    { kind: 'COUNTRY', code: 'MA', name: 'Morocco' },
    { kind: 'COUNTRY', code: 'MZ', name: 'Mozambique' },
    { kind: 'COUNTRY', code: 'MM', name: 'Myanmar' },
    { kind: 'COUNTRY', code: 'NA', name: 'Namibia' },
    { kind: 'COUNTRY', code: 'NR', name: 'Nauru' },
    { kind: 'COUNTRY', code: 'NP', name: 'Nepal' },
    { kind: 'COUNTRY', code: 'NL', name: 'Netherlands' },
    { kind: 'COUNTRY', code: 'NC', name: 'New Caledonia' },
    { kind: 'COUNTRY', code: 'NZ', name: 'New Zealand' },
    { kind: 'COUNTRY', code: 'NI', name: 'Nicaragua' },
    { kind: 'COUNTRY', code: 'NE', name: 'Niger' },
    { kind: 'COUNTRY', code: 'NG', name: 'Nigeria' },
    { kind: 'COUNTRY', code: 'NU', name: 'Niue' },
    { kind: 'COUNTRY', code: 'NF', name: 'Norfolk Island' },
    { kind: 'COUNTRY', code: 'KP', name: 'North Korea' },
    { kind: 'COUNTRY', code: 'MK', name: 'North Macedonia' },
    { kind: 'COUNTRY', code: 'MP', name: 'Northern Mariana Islands' },
    { kind: 'COUNTRY', code: 'NO', name: 'Norway' },
    { kind: 'COUNTRY', code: 'OM', name: 'Oman' },
    { kind: 'COUNTRY', code: 'PK', name: 'Pakistan' },
    { kind: 'COUNTRY', code: 'PW', name: 'Palau' },
    { kind: 'COUNTRY', code: 'PS', name: 'Palestine' },
    { kind: 'COUNTRY', code: 'PA', name: 'Panama' },
    { kind: 'COUNTRY', code: 'PG', name: 'Papua New Guinea' },
    { kind: 'COUNTRY', code: 'PY', name: 'Paraguay' },
    { kind: 'COUNTRY', code: 'PE', name: 'Peru' },
    { kind: 'COUNTRY', code: 'PH', name: 'Philippines' },
    { kind: 'COUNTRY', code: 'PN', name: 'Pitcairn Islands' },
    { kind: 'COUNTRY', code: 'PL', name: 'Poland' },
    { kind: 'COUNTRY', code: 'PT', name: 'Portugal' },
    { kind: 'COUNTRY', code: 'PR', name: 'Puerto Rico' },
    { kind: 'COUNTRY', code: 'QA', name: 'Qatar' },
    { kind: 'COUNTRY', code: 'CG', name: 'Republic of the Congo' },
    { kind: 'COUNTRY', code: 'RE', name: 'Reunion' },
    { kind: 'COUNTRY', code: 'RO', name: 'Romania' },
    { kind: 'COUNTRY', code: 'RU', name: 'Russia' },
    { kind: 'COUNTRY', code: 'RW', name: 'Rwanda' },
    { kind: 'COUNTRY', code: 'BL', name: 'Saint Barthelemy' },
    { kind: 'COUNTRY', code: 'SH', name: 'Saint Helena' },
    { kind: 'COUNTRY', code: 'KN', name: 'Saint Kitts and Nevis' },
    { kind: 'COUNTRY', code: 'LC', name: 'Saint Lucia' },
    { kind: 'COUNTRY', code: 'MF', name: 'Saint Martin' },
    { kind: 'COUNTRY', code: 'PM', name: 'Saint Pierre and Miquelon' },
    { kind: 'COUNTRY', code: 'VC', name: 'Saint Vincent and the Grenadines' },
    { kind: 'COUNTRY', code: 'WS', name: 'Samoa' },
    { kind: 'COUNTRY', code: 'SM', name: 'San Marino' },
    { kind: 'COUNTRY', code: 'ST', name: 'Sao Tome and Principe' },
    { kind: 'COUNTRY', code: 'SA', name: 'Saudi Arabia' },
    { kind: 'COUNTRY', code: 'SN', name: 'Senegal' },
    { kind: 'COUNTRY', code: 'RS', name: 'Serbia' },
    { kind: 'COUNTRY', code: 'SC', name: 'Seychelles' },
    { kind: 'COUNTRY', code: 'SL', name: 'Sierra Leone' },
    { kind: 'COUNTRY', code: 'SG', name: 'Singapore' },
    { kind: 'COUNTRY', code: 'SX', name: 'Sint Maarten' },
    { kind: 'COUNTRY', code: 'SK', name: 'Slovakia' },
    { kind: 'COUNTRY', code: 'SI', name: 'Slovenia' },
    { kind: 'COUNTRY', code: 'SB', name: 'Solomon Islands' },
    { kind: 'COUNTRY', code: 'SO', name: 'Somalia' },
    { kind: 'COUNTRY', code: 'ZA', name: 'South Africa' },
    { kind: 'COUNTRY', code: 'GS', name: 'South Georgia and the South Sandwich Islands' },
    { kind: 'COUNTRY', code: 'KR', name: 'South Korea' },
    { kind: 'COUNTRY', code: 'SS', name: 'South Sudan' },
    { kind: 'COUNTRY', code: 'ES', name: 'Spain' },
    { kind: 'COUNTRY', code: 'LK', name: 'Sri Lanka' },
    { kind: 'COUNTRY', code: 'SD', name: 'Sudan' },
    { kind: 'COUNTRY', code: 'SR', name: 'Suriname' },
    { kind: 'COUNTRY', code: 'SJ', name: 'Svalbard and Jan Mayen' },
    { kind: 'COUNTRY', code: 'SE', name: 'Sweden' },
    { kind: 'COUNTRY', code: 'CH', name: 'Switzerland' },
    { kind: 'COUNTRY', code: 'SY', name: 'Syria' },
    { kind: 'COUNTRY', code: 'TW', name: 'Taiwan' },
    { kind: 'COUNTRY', code: 'TJ', name: 'Tajikistan' },
    { kind: 'COUNTRY', code: 'TZ', name: 'Tanzania' },
    { kind: 'COUNTRY', code: 'TH', name: 'Thailand' },
    { kind: 'COUNTRY', code: 'TG', name: 'Togo' },
    { kind: 'COUNTRY', code: 'TK', name: 'Tokelau' },
    { kind: 'COUNTRY', code: 'TO', name: 'Tonga' },
    { kind: 'COUNTRY', code: 'TT', name: 'Trinidad and Tobago' },
    { kind: 'COUNTRY', code: 'TA', name: 'Tristan da Cunha' },
    { kind: 'COUNTRY', code: 'TN', name: 'Tunisia' },
    { kind: 'COUNTRY', code: 'TR', name: 'Türkiye' },
    { kind: 'COUNTRY', code: 'TM', name: 'Turkmenistan' },
    { kind: 'COUNTRY', code: 'TC', name: 'Turks and Caicos Islands' },
    { kind: 'COUNTRY', code: 'TV', name: 'Tuvalu' },
    { kind: 'COUNTRY', code: 'UM', name: 'U.S. Minor Outlying Islands' },
    { kind: 'COUNTRY', code: 'VI', name: 'U.S. Virgin Islands' },
    { kind: 'COUNTRY', code: 'UG', name: 'Uganda' },
    { kind: 'COUNTRY', code: 'UA', name: 'Ukraine' },
    { kind: 'COUNTRY', code: 'AE', name: 'United Arab Emirates' },
    { kind: 'COUNTRY', code: 'GB', name: 'United Kingdom' },
    { kind: 'COUNTRY', code: 'US', name: 'United States' },
    { kind: 'COUNTRY', code: 'UY', name: 'Uruguay' },
    { kind: 'COUNTRY', code: 'UZ', name: 'Uzbekistan' },
    { kind: 'COUNTRY', code: 'VU', name: 'Vanuatu' },
    { kind: 'COUNTRY', code: 'VA', name: 'Vatican City' },
    { kind: 'COUNTRY', code: 'VE', name: 'Venezuela' },
    { kind: 'COUNTRY', code: 'VN', name: 'Vietnam' },
    { kind: 'COUNTRY', code: 'WF', name: 'Wallis and Futuna' },
    { kind: 'COUNTRY', code: 'EH', name: 'Western Sahara' },
    { kind: 'COUNTRY', code: 'YE', name: 'Yemen' },
    { kind: 'COUNTRY', code: 'ZM', name: 'Zambia' },
    { kind: 'COUNTRY', code: 'ZW', name: 'Zimbabwe' },
] as const satisfies readonly PreflightMarketCatalogueEntry[];
